import axios from 'axios'
import config from '@/config'

export default {
    getEmployee(branch, dep, position, search, page) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/findEmpListByBranch`, {
            params: {
                'branch': branch,
                'dep': dep,
                'position': position,
                'search': search,
                'page': page,
                companyid: _company_guid,
            },
      
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getAllEmployee() {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/AllEmp`, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getEmployeeInactive(branch, dep, position, search, page) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/findEmpUnactiveListByBranch`, {
            params: {
                'branch': branch,
                'dep': dep,
                'position': position,
                'search': search,
                'page': page,
                companyid: _company_guid,
            },
         
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    
    getEmployeeImage(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/emp-image/` + data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    createEmployee(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/employee`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    updateEmployee(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.put(`/employee`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    deleteEmployee(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.delete(`/employee/` + data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getEmployeeDetail(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/detail/` + data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    findEmpPermission(){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/findEmpPermission/`,{ 
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    CreateEmpPermission(data){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/permission-control/user`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getPermissionbyEmp(empcode){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/permission-control/user/`+ empcode,{ 
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    EmployeeActive(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/unactive/`+data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    EmployeeReactive(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/reactive/`+data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    importEmployee(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/employee/import-employee`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    importEmployeeUpdate(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/employee/import-update`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    CreateGroupPermission(data){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/permission-control/group`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    CreateEmpGroupPermission(data){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`permission-control/user-group`, data, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    
    getPermissionbyGroup(groupcode){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/permission-control/group/`+ groupcode,{ 
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getGroupPermission(){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/permission-control/group/`,{ 
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    deleteGroup(groupcode) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.delete(`/permission-control/` + groupcode, {
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getUserPermissionbyGroup(groupcode){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/permission-control/user-group/`+ groupcode,{ 
            params: {
                companyid: _company_guid,
              },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },

    
}